import { ValidModelObject } from '../../classDependentTypes';
import { roundDecimals } from '../../util';

/**
 * @exports https://blog.ampow.com/lipo-voltage-chart/
 * */
export const lipoVoltageArray = [3.27, 3.61, 3.69, 3.71, 3.73, 3.75, 3.77, 3.79, 3.8, 3.82, 3.84, 3.85, 3.87, 3.91, 3.95, 3.98, 4.02, 4.08, 4.11, 4.15, 4.2]

const modifiedVoltageArray = (minVoltage: number, maxVoltage: number): number[] => {
  let base = lipoVoltageArray[0]
  let diff = lipoVoltageArray[lipoVoltageArray.length - 1] - lipoVoltageArray[0]
  let cummulative = lipoVoltageArray.map((val) => {
    let calc = (val - base) / diff
    return calc
  })

  let converted = cummulative.map((val) => {
    let conv = minVoltage
    let diff = (maxVoltage - minVoltage) * val
    return conv + diff
  })
  return converted
}

const calculateSpecificPercentage = (voltage: number, voltageArray: number[]): number => {
  let length = voltageArray.length
  if (length < 1) throw new Error('FFS, calculateSpecificPercentage')
  let percentageIncrement = 100 / (length - 1)

  let exact = voltageArray.findIndex((val) => val === voltage)
  let upper = voltageArray.findIndex((val) => val >= voltage)

  let index = exact !== -1 ? exact : upper - 1
  let fromIndex = percentageIncrement * index
  let granular = 0

  if (exact !== upper) {
    granular = ((voltage - voltageArray[index]) / (voltageArray[upper] - voltageArray[index])) * percentageIncrement
  }

  return fromIndex + granular
}

const calculateVoltage = (percentage: number, voltageArray: number[]): number => {
  let length = voltageArray.length

  let percentageIncrement = 100 / (length - 1)
  if (length < 2) throw new Error('FFS, calculateVoltage')
  let index = Math.floor(percentage / percentageIncrement)

  let remainder = percentage - index * percentageIncrement

  let remainderPercentage = remainder / percentageIncrement

  let voltDiff = voltageArray[index + 1] - voltageArray[index]

  let voltBetween = voltDiff * remainderPercentage

  return voltageArray[index] + voltBetween
}

/**
 * @exports https://docs.google.com/spreadsheets/d/1d4nQKwsdbR-UDWHC8PouWinJUh7O0zSDvPPbT041Ns0/edit#gid=0
 */
export const CalculateBatteryFromVoltages = (voltage: number, minVoltage: number = 3.27, maxVoltage: number = 4.2): number => {
  if (voltage >= maxVoltage) {
    return 100
  } else if (voltage <= minVoltage) {
    return 0
  }

  let calcVoltageArray = modifiedVoltageArray(minVoltage, maxVoltage);
  let res = calculateSpecificPercentage(voltage, calcVoltageArray);
  return roundDecimals(res,0);
};

export const CalculateVoltageFromBattery = (percentage: number, minVoltage: number = 3.27, maxVoltage: number = 4.2): number => {
  if (percentage >= 100) {
    return maxVoltage
  } else if (percentage <= 0) {
    return minVoltage
  }

  let calcVoltageArray = modifiedVoltageArray(minVoltage, maxVoltage)
  let res = calculateVoltage(percentage, calcVoltageArray)
  return res
}

export const CalculateBattery = (device: ValidModelObject<'Device'>): number | undefined => {
  if (device.batteryCapacity) {
    return CalculateBatteryFromVoltages(device.batteryCapacity, device.minVoltage, device.maxVoltage)
  }
  return undefined
}
